import * as j from '@mojotech/json-type-validation';

import { Message as AsyncMessage, MessageResponseDecoder } from '~services/AsyncManager/domain';

export const GetAsyncTranscriptResponseDecoder: j.Decoder<{ [key: string]: AsyncMessage }> =
  j.dict(MessageResponseDecoder);
